import { useState, type FormEvent } from "react";

interface Comment {
  id: number;
  user: string;
  avatarColor: string;
  time: string;
  content: string;
}

const initialComments: Comment[] = [
  {
    id: 1,
    user: "樱花味的风",
    avatarColor: "bg-primary-100 text-primary-700",
    time: "2 小时前",
    content: "分镜真的太稳了，尤其是中段那场独白，配乐一起来直接起鸡皮疙瘩。",
  },
  {
    id: 2,
    user: "宇宙观测员",
    avatarColor: "bg-secondary-100 text-secondary-900",
    time: "昨天",
    content: "角色塑造很扎实，喜欢这种不着急推进剧情、先把人物立住的做法。",
  },
  {
    id: 3,
    user: "深夜看番组",
    avatarColor: "bg-accent-100 text-accent-900",
    time: "3 天前",
    content: "美术风格很统一，随手一截都能当壁纸，期待后面的剧情发展。",
  },
];

export default function CommentSection({ onToast }: { onToast: (msg: string) => void }) {
  const [comments, setComments] = useState<Comment[]>(initialComments);
  const [text, setText] = useState("");

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    const value = text.trim();
    if (!value) return;
    if (value.length > 200) {
      onToast("评论最多 200 字，请精简后再提交");
      return;
    }
    setComments((prev) => [
      {
        id: Date.now(),
        user: "我",
        avatarColor: "bg-primary-500 text-background-50",
        time: "刚刚",
        content: value,
      },
      ...prev,
    ]);
    setText("");
    onToast("已发表（演示模式，刷新后不会保存）");
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">评论区</h2>
        <span className="text-xs text-foreground-500 flex items-center gap-1">
          <i className="ri-information-line" />
          演示模块 · 不存储数据
        </span>
      </div>

      <form onSubmit={handleSubmit} className="rounded-lg border border-background-200 bg-background-50 p-4">
        <div className="flex gap-3">
          <span className="w-9 h-9 shrink-0 rounded-full bg-secondary-100 text-secondary-900 flex items-center justify-center">
            <i className="ri-user-3-line" />
          </span>
          <div className="flex-1 min-w-0">
            <textarea
              value={text}
              onChange={(event) => setText(event.target.value)}
              maxLength={200}
              rows={3}
              placeholder="说说你对这部动画的看法……（最多 200 字）"
              className="w-full resize-none rounded-md border border-background-200 bg-background-100 px-3 py-2 text-sm text-foreground-900 placeholder:text-foreground-500 outline-none focus:border-primary-300 transition-colors"
            />
            <div className="mt-2 flex items-center justify-between">
              <span className="text-xs text-foreground-500">{text.length}/200</span>
              <button
                type="submit"
                className="px-4 h-9 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                发表评论
              </button>
            </div>
          </div>
        </div>
      </form>

      <ul className="mt-5 space-y-4">
        {comments.map((comment) => (
          <li key={comment.id} className="flex gap-3">
            <span className={`w-9 h-9 shrink-0 rounded-full flex items-center justify-center text-sm font-semibold ${comment.avatarColor}`}>
              {comment.user.slice(0, 1)}
            </span>
            <div className="flex-1 min-w-0 pb-4 border-b border-background-200">
              <div className="flex items-center gap-2">
                <span className="text-sm font-semibold text-foreground-950">{comment.user}</span>
                <span className="text-xs text-foreground-500">{comment.time}</span>
              </div>
              <p className="mt-1 text-sm leading-relaxed text-foreground-700">{comment.content}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}